<template>
  <div id="app">
    <el-container>
      <el-aside v-if="$store.getters.isAuthenticated" width="250px">
        <Menu />
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";

import { SET_AXIOS_TOKEN } from "@/store/actions/auth";

export default {
  components: {
    Menu
  },
  created() {
    this.$store.dispatch(SET_AXIOS_TOKEN);
  }
};
</script>

<style lang="sass">

html, body, #app
  height: 100%
  min-width: 550px

html
  font-family: "Source Sans Pro" !important

a
  text-decoration: none
  color: $--color-text-regular

  &:visited
    color: $--color-text-regular  

h1, h2, h3, h4
  color: $--color-text-primary

</style>

<style scoped lang="sass">

.el-container, .el-aside, .el-main, .router-view
  height: 100%
  background-color: $--background-color-base

.el-main
  padding: 0px

</style>